import {SelectField} from '@ui/molecules/select/selectfield';
import {useMemo} from 'react';
import {useStoreContext} from '@store/store-context';
import styled from 'styled-components';
import {getColorFromTheme} from '@ui/ui-utils';

const PublicVisibilityValue = styled.div`
  display: flex;
  width: 100%;
  height: 52px;
  align-items: center;
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 10px;
  background: ${getColorFromTheme('backgroundDark')};
  padding: 0 16px;
  color: ${getColorFromTheme('textBody')};
  font-family: Graphik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const FeedBackType = ({
  updateValue,
  value,
  user,
  disabled,
  includePublic,
  error,
}: {
  updateValue: (value: any) => void;
  value: string;
  user?: string;
  includePublic?: boolean;
  disabled?: boolean;
  error?: string;
}) => {
  const {
    authStore: {auth},
    usersStore: {users},
  } = useStoreContext();

  const values = useMemo(() => {
    const options = [
      {
        label: 'Private — You and recipient',
        value: 'private',
      },
    ];
    if (includePublic) {
      options.unshift({
        label: 'Public',
        value: 'public',
      });
    }
    const isSelectedUserManager =
      users.find((_user) => _user.id === user)?.reviewer?.id === auth.user.id;

    if (!isSelectedUserManager) {
      options.splice(1, 0, {
        label: 'Private + manager — You, recipient and manager',
        value: 'manager',
      });
    }
    return options;
  }, [user, auth.user.id, users, includePublic]);

  if (includePublic && disabled) {
    return <PublicVisibilityValue>Public</PublicVisibilityValue>;
  }

  return (
    <SelectField
      options={values}
      placeholder="Select"
      helper={error}
      disabled={disabled}
      state={error ? 'error' : 'default'}
      defaultValue={value}
      borderRadius={10}
      excludeSearchBox
      selectedValueFontSize="14px"
      onChange={(e: any) => {
        updateValue(e?.value);
      }}
    />
  );
};
